
import {defineComponent, PropType} from 'vue';
import MenuItem from './types';
import MainMenuItem from './MainMenuItem.vue';
import Icon from '@ohrm/oxd/core/components/Icon/Icon.vue';
import Input from '@ohrm/oxd/core/components/Input/Input.vue';
import IconButton from '@ohrm/oxd/core/components/Button/Icon.vue';
import usei18n from '../../../composables/usei18n';

export default defineComponent({
  name: 'oxd-main-menu',

  emits: ['collapse'],

  setup() {
    return {
      ...usei18n(),
    };
  },

  data() {
    return {
      searchTerm: '',
    };
  },

  props: {
    url: {
      type: String,
      default: '/',
    },
    toggle: {
      type: Boolean,
      default: false,
    },
    menuItems: {
      type: Object as PropType<MenuItem[]>,
    },
  },

  components: {
    'oxd-icon': Icon,
    'oxd-input': Input,
    'oxd-icon-button': IconButton,
    'oxd-main-menu-item': MainMenuItem,
  },

  methods: {
    onClickCollapse() {
      this.$emit('collapse');
      // trigger resize event for body resize event listners
      // timeout delay is added for sidebar animation 0.3s
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 350);
    },
  },

  computed: {
    classes(): object {
      return {
        toggled: this.toggle,
      };
    },
    filteredMenuItems(): MenuItem[] {
      const filter = new RegExp(this.searchTerm, 'i');
      return this.menuItems.filter(item => item.name.match(filter));
    },
  },
});
